export default "__VITE_ASSET__144f4dbd__"